// extracted by mini-css-extract-plugin
export var autoExpand = "_4g-8";
export var container = "_4g-7";
export var containerWidth = "_4g-5";
export var disabled = "_4g-2";
export var error = "_4g-3";
export var fullWidth = "_4g-6";
export var inputWrapper = "_4g-0";
export var small = "_4g-1";
export var textarea = "_4g-4";